{
  "R": [68, 49, 53, 253],
  "G": [1, 104, 183, 231],
  "B": [84, 142, 121, 37],
  "A": [0, 56, 80, 88],
  "I": [0, 64, 192, 255]
}
